<div class="ai-summary-container">
  <div class="ai-summary-top horizontal-line">
    <div class="ai-summary-section">
      <div class="ai-summary-header">
        <div class="ai-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="24"
              height="24"
              rx="9"
              fill="url(#paint0_linear_1261_16024)"
            />
            <g clip-path="url(#clip0_1261_16024)">
              <path
                d="M14.6667 16C15.0203 16 15.3594 16.1405 15.6095 16.3905C15.8595 16.6406 16 16.9797 16 17.3334C16 16.9797 16.1405 16.6406 16.3905 16.3905C16.6406 16.1405 16.9797 16 17.3333 16C16.9797 16 16.6406 15.8595 16.3905 15.6095C16.1405 15.3594 16 15.0203 16 14.6667C16 15.0203 15.8595 15.3594 15.6095 15.6095C15.3594 15.8595 15.0203 16 14.6667 16ZM14.6667 8.00002C15.0203 8.00002 15.3594 8.1405 15.6095 8.39054C15.8595 8.64059 16 8.97973 16 9.33335C16 8.97973 16.1405 8.64059 16.3905 8.39054C16.6406 8.1405 16.9797 8.00002 17.3333 8.00002C16.9797 8.00002 16.6406 7.85954 16.3905 7.6095C16.1405 7.35945 16 7.02031 16 6.66669C16 7.02031 15.8595 7.35945 15.6095 7.6095C15.3594 7.85954 15.0203 8.00002 14.6667 8.00002ZM10 16C10 14.9392 10.4214 13.9217 11.1716 13.1716C11.9217 12.4214 12.9391 12 14 12C12.9391 12 11.9217 11.5786 11.1716 10.8284C10.4214 10.0783 10 9.06089 10 8.00002C10 9.06089 9.57857 10.0783 8.82843 10.8284C8.07828 11.5786 7.06087 12 6 12C7.06087 12 8.07828 12.4214 8.82843 13.1716C9.57857 13.9217 10 14.9392 10 16Z"
                stroke="white"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_1261_16024"
                x1="7.36364"
                y1="5.45454"
                x2="28.3636"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#CA43FB" />
                <stop offset="1" stop-color="#3C31DB" />
              </linearGradient>
              <clipPath id="clip0_1261_16024">
                <rect
                  width="16"
                  height="16"
                  fill="white"
                  transform="translate(4 4)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <h3 class="summary-title">AI Summary</h3>
        <div class="progress-tag">
          <div class="rect" [ngClass]="progressTagClass">
            {{ progressTagMsg }}
          </div>
        </div>
      </div>
    </div>

    @if (progressTimeText) {
      <div class="col-4 gradient-border">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1261_16033)">
            <path
              d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C7.21207 2 6.43185 2.15519 5.7039 2.45672C4.97595 2.75825 4.31451 3.20021 3.75736 3.75736C3.20021 4.31451 2.75825 4.97595 2.45672 5.7039C2.15519 6.43185 2 7.21207 2 8Z"
              stroke="#1B9AE3"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8 8H10.3333"
              stroke="#1B9AE3"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8 4.66669V8.00002"
              stroke="#1B9AE3"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1261_16033">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <div class="score-badge content">{{ progressTimeText }}</div>
        <div class="process-time">{{ progressTime }}</div>
      </div>
    }
  </div>
  @if (
    aiSummaryContent ||
    confidenceScore ||
    courseCount ||
    courseMatched ||
    courseNotMatched
  ) {
    <div class="ai-summary-bottom">
      <div class="ai-summary-content">
        @if (aiSummaryContent) {
          <div class="ai-content-body">
            {{ aiSummaryContent }}
          </div>
        }
        <div class="ai-content-footer horizontal-line">
          <div class="ai-content-item horizontal-line">
            @if (courseCount !== null && courseCount !== undefined) {
              <div class="ai-content-course-count">
                <svg
                  width="6"
                  height="6"
                  viewBox="0 0 6 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="6" height="6" rx="3" fill="#1B9AE3" />
                </svg>
                <span class="total-course-count">{{ courseCount }}</span>
                Total Courses
              </div>
            }
            @if (courseMatched !== null && courseMatched !== undefined) {
              <div class="ai-content-course-count">
                <svg
                  width="6"
                  height="6"
                  viewBox="0 0 6 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="6" height="6" rx="3" fill="#1B9AE3" />
                </svg>
                <span class="total-course-count">{{ courseMatched }}</span>
                Course matched
              </div>
            }
            @if (
              transferForCredit !== null && transferForCredit !== undefined
            ) {
              <div>
                <svg
                  width="6"
                  height="6"
                  viewBox="0 0 6 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="6" height="6" rx="3" fill="#1E9550" />
                </svg>
                <span class="total-course-count">{{ transferForCredit }}</span>
                Transfer for Credit
              </div>
            }
            @if (
              notTransferForCredit !== null &&
              notTransferForCredit !== undefined
            ) {
              <div>
                <svg
                  width="6"
                  height="6"
                  viewBox="0 0 6 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="6" height="6" rx="3" fill="#FA0000" />
                </svg>
                <span class="total-course-count">{{
                  notTransferForCredit
                }}</span>
                Not Transfer for Credit
              </div>
            }
            @if (courseNotMatched !== null && courseNotMatched !== undefined) {
              <div>
                <svg
                  width="6"
                  height="6"
                  viewBox="0 0 6 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="6" height="6" rx="3" fill="#1E9550" />
                </svg>
                <span class="total-course-count">{{ courseNotMatched }}</span>
                Courses not matched
              </div>
            }
            @if (flaggedCount !== null && flaggedCount !== undefined) {
              <div class="ai-content-flagged-item horizontal-line">
                <app-mmp-flag-component></app-mmp-flag-component>
                <span class="flagged-count">{{ flaggedCount }}</span> Items
                Flagged for Review
              </div>
            }
          </div>
          @if (confidenceScore) {
            <div class="confidence-score-section">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1566_2757)">
                  <path
                    d="M8 2L10 6L14 8L10 10L8 14L6 10L2 8L6 6L8 2Z"
                    stroke="#C64FEA"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1566_2757">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span class="confidence-span"
                ><b>{{ confidenceScore }}%</b></span
              >
              AI is Confidence in {{ currentTab }}
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
